const NightParticlesConfig = {
     particles: {
       number: {
         value: 80,
         density: {
           enable: true,
           value_area: 800
         }
       },
       color: {
         value: "#FFFFFF"
       },
       shape: {
         type: "circle",
         stroke: {
           width: 0,
           color: "#000000"
         },
         polygon: {
           nb_sides: 5
         },
         image: {
           src: "img/github.svg",
           width: 100,
           height: 100
         }
       },
       opacity: {
         value: 0.25,
         random: false,
         anim: {
           enable: false,
           speed: 0.5,
           opacity_min: 0.1,
           sync: false
         }
       },
       size: {
         value: 3,
         random: true,
         anim: {
           enable: false,
           speed: 20,
           size_min: 0.1,
           sync: false
         }
       },
       line_linked: {
         enable: true,
         distance: 150,
         color: "#FFFFFF",
         opacity: 0.2,
         width: 1
       },
       move: {
         enable: true,
         speed: 3,
         direction: "none",
         random: false,
         straight: false,
         out_mode: "out",
         bounce: false,
         attract: {
           enable: false,
           rotateX: 600,
           rotateY: 1200
         }
       }
     },
     interactivity: {
       detect_on: "canvas",
       events: {
         onhover: {
           enable: false,
           mode: "repulse"
         },
         onclick: {
           enable: false,
           mode: "push"
         },
         resize: true
       },
       modes: {
         grab: {
           distance: 400,
           line_linked: {
             opacity: 0.5
           }
         },
         bubble: {
           distance: 400,
           size: 40,
           duration: 2,
           opacity: 4,
           speed: 1.5
         },
         repulse: {
           distance: 200,
           duration: 0.4
         },
         push: {
           particles_nb: 4
         },
         remove: {
           particles_nb: 2
         }
       }
     },
     retina_detect: true
   }
   
   export default NightParticlesConfig;